define('modules/editor/views/elements/form_button',['require','exports','module','./element','underscore','ldsh!../../templates/elements/form_button'],function(require, exports, module){
  "use strict";

  var Element = require("./element"),
      _ = require("underscore");

  var FormButton = module.exports = Element.extend({
    initialize: function() {
      return module.exports.__super__.initialize.apply(this, arguments);
    },
    template: require("ldsh!../../templates/elements/form_button"),
    className: "ed-form-button ed-panel-item",
    // the algorithm doesn't work (and isn't needed) for the button
    _adjustSize: _.identity,
    onEditContent: function(){
      this.model.formModel.editFormFields();
    },
  });
});

